export default "__VITE_ASSET__fYXou5OF__"